import { createTenantSecretMapping } from 'TenantModule/services';
import {
  CreateTenantSecretMappingErrorResponse,
  CreateTenantSecretMappingPayload,
  CreateTenantSecretMappingSuccessResponse,
} from 'TenantModule/types';
import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { AxiosResponse } from 'axios';
import { useNotification } from 'hooks/useNotification';

export const useCreateTenantSecretMapping = () => {
  const token = useSelector(selectAuthToken);
  const { showSuccess, showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<CreateTenantSecretMappingSuccessResponse>, // Expected response type
    AxiosResponse<CreateTenantSecretMappingErrorResponse>, // Error type
    CreateTenantSecretMappingPayload // Argument type for the mutation function
  >({
    mutationKey: ['createTenantSecretMapping'],
    mutationFn: async (params) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return createTenantSecretMapping({ params, token });
    },
    onSuccess: (data) => {
      // ✅ FIX: Replace alert() with toast notification
      showSuccess('Tenant secrets mapping successful!');
    },
    onError: (error) => {
      // ✅ FIX: Replace alert() with toast notification
      showError(`Tenant secrets mapping failed! ${error.data.message}`);
    },
  });
  return {
    createTenantSecretMapping: mutation.mutate,
    isCreatingTenantSecretMapping: mutation.isPending,
  };
};
